import { SpriteIcon } from "@components/core/icons/SpriteIcon";
import styled from "styled-components";

export const InfoIconStyled = styled(SpriteIcon)`
  min-width: 1rem;
  min-height: 1rem;
  cursor: pointer;
  stroke: ${(props) => props.theme.colors.green[300].accent};

  &:hover {
    stroke: ${(props) => props.theme.colors.green[300].stroke};
  }
`;

export const BeatbotInfoButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-left: 0.5rem;
  }
`;

export const BeatbotModalTitle = styled.h2`
  font-size: 1rem;
`;

export const BeatbotModalBody = styled.p`
  font-size: 1rem;
  max-width: 28rem;
  white-space: pre-line;
  font-weight: normal;
  line-height: normal;
  color: ${(props) => props.theme.colors.neutrals.secondary.gray.indicator2};
`;
